import * as React from "react"
const ColumnIcon = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 250 250" {...props}>
    <path d="M202.1 12.5c-3.7 0-6.8 3-6.8 6.8v14.6H54.6V19.3c0-3.7-3-6.8-6.8-6.8-3.7 0-6.8 3-6.8 6.8v21.4c0 3.7 3 6.8 6.8 6.8h154.3c3.7 0 6.8-3 6.8-6.8V19.3c0-3.8-3-6.8-6.8-6.8M130 120.7v9.7h8.7c2.5 0 4.6-1.9 4.8-4.4l6-62.6c.1-1.4-.3-2.7-1.2-3.7s-2.2-1.6-3.6-1.6h-39.4c-1.4 0-2.7.6-3.6 1.6s-1.4 2.4-1.2 3.7l6 62.6c.2 2.5 2.3 4.4 4.8 4.4h8.7v-9.7h-4.3l-5.1-52.9h28.7l-5.1 52.9zm-32.6 89.2c0 15.3 12.4 27.6 27.6 27.6s27.6-12.3 27.6-27.6c0-21.3-22-42.2-27.6-76.1-5.5 34-27.6 54.9-27.6 76.1" />
  </svg>
)
export default ColumnIcon
